/* eslint-disable @typescript-eslint/no-empty-function */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MsgToUser } from './msgs-to-user/models/MsgToUser.model';

@Injectable({
  providedIn: 'root'
})
export class MsgsToUserService {

  private msgToUser = new BehaviorSubject<MsgToUser>(new MsgToUser("", ""));

  msgToUserAsObservable = this.msgToUser.asObservable();

  constructor() {

  }

  setMsgsToUser(msgToUser: MsgToUser) {

    this.msgToUser.next(msgToUser);

  }

  closeMsgsToUser(msgToUser: MsgToUser) {

    this.msgToUser.next(msgToUser);

  }
}
